import api from './api'
import VPager from './VPager'
// import dateformat from './dateformat'

export default function info (parentId) {

	const myapp = new Vue({
		delimiters: ['${', '}'],
		el: '#v-info',
		components: {VPager},
		data () {
			return {
				perpage: 20,
				total: 0,
				loading: false,
				items: null,
				page: (() => {
					const matched = location.search.match(/^\?page\=(\d+)/)
					return matched ? matched[1] - 0 : 1
				})()
			}
		},
		computed: {
		},
		watch: {
			page () {
				this.load()
			}
		},
		methods: {
			load () {
				this.loading = true
				this.items = null
				const params = {
					parent: parentId,
					limit: this.perpage,
					page_no: this.page,
					except_emergency: true
				}
				return api.pages(params).then(res => {
					this.items = res.data
					this.total = this.perpage * res.pager.max
					this.loading = false
				})
			},
			changePage (page) {
				this.page = page

				// ページをURLに反映
				const url = location.pathname + (this.page >= 2 ? `?page=${this.page}` : ``)
				history.replaceState(null, null, url)

				// 上へスクロール
				const y = window.pageYOffset + this.$el.getBoundingClientRect().top
				window.scrollTo(0, y)
			}
		},
		created () {
			this.load()
		}
	})

}